import { render, staticRenderFns } from "./learning-method.vue?vue&type=template&id=6e4d3b64&scoped=true&"
import script from "./learning-method.vue?vue&type=script&lang=js&"
export * from "./learning-method.vue?vue&type=script&lang=js&"
import style0 from "./learning-method.vue?vue&type=style&index=0&id=6e4d3b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d3b64",
  null
  
)

export default component.exports